import {Component, Inject, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {AppSettings} from "~/lib/app-settings";
import TagsList from "~/components/tags-list";
import {createClientTag, getClientTags, removeClientTags} from "~/modules/settings/services";

@Component
export class Metas extends Vue {

  @Getter currentUser;
  @Inject() appSettings: AppSettings;

  protected isLoading = false;
  protected tags: {id:number, label:string}[] = [];
  protected newTagLabel:string = null;

  async created(){
    this.isLoading = true;
    this.tags = await getClientTags(this.appSettings.clientUUID);
    this.isLoading = false;
  }

  async createTag(){
    if (this.newTagLabel) {
      let newTag = await createClientTag(this.appSettings.clientUUID, this.newTagLabel);
      this.tags.push(newTag);
      this.newTagLabel = "";
    }
  }

  async removeTag(tag){
    this.tags = this.tags.filter(t => t.id !== tag.id);
    await removeClientTags(this.appSettings.clientUUID, tag);
  }

  renderTags(){
    if( this.isLoading ) return <p>Chargement</p>
    if( this.tags.length === 0 ) return <p>Aucune thématique</p>
    return <TagsList items={this.tags} labelRenderer={v => v.label} onRemoveTag={this.removeTag}/>;
  }

  handleKeypress(e) {
    if (e.keyCode === 13) this.createTag();
  }

  renderCreator(){
    return (
      <div class="field has-addons">
        <div class="control">
          <input
            type="text"
            class="input is-small"
            onKeypress={this.handleKeypress}
            v-model={this.newTagLabel}
            placeholder="Nouvelle thématique"
          />
        </div>
        <div class="control">
          <button class="button is-small" onClick={this.createTag}>Enregistrer</button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <h2 class="page-subtitle">Thématiques</h2>
        {this.renderCreator()}
        {this.renderTags()}
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2b1214cc/metas.tsx" });